<template>
  <div :style="'height: '+height+'px'">
    <cube-index-list :data="list" :title="title" @select="selectItem"></cube-index-list>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      height: "",
      platform: "",
      from: "",
      redirect: "",
      encodeToken: "",
      token: "",
      title: "网点 / 区域列表",
      list: []
    };
  },
  created() {
    this.height = window.innerHeight - 10;
    let routerParams = this.$route.params;

    this.encodeToken = routerParams.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    this.platform = routerParams.platform;
    this.from = routerParams.from;
    this.redirect = routerParams.redirect;

    axios
      .get("/api/worksite/listByGroup")
      .then(res => {
        if (res.data.success) {
          this.list = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    selectItem(item) {
      if (this.from == "userInfo") {
        // 修改网点
        axios
          .put("/api/user/updateWorksite", { worksite: item.value })
          .then(res => {
            if (res.data.success) {
              weui.toast("网点变更成功", 1000);
              // 跳转回个人中心页面
              this.$router.push(
                "/userInfo/" + this.platform + "/" + this.encodeToken
              );
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            weui.alert("保存失败");
          });
      } else if (this.from == "addUserInfo") {
        let choosedWs = {
          label: item.shortName,
          value: item.value
        };
        sessionStorage.setItem("choosedWs", JSON.stringify(choosedWs));
        this.$router.push(
          "/addUserInfo/" + this.redirect + "/" + this.encodeToken
        );
      }
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/operations/WorksiteList.vue